/**
 * The body of a `widget/update`.
 *
 * It used to drop `dataSource` unless the query had changed: sending it
 * unchanged on a v1 widget regenerated the query, and "[fix] Employee Table"
 * went from three rows to none (dev, 2026-10-01).
 *
 * The rev4 backend reverses both halves of that. Sending it is what the
 * contract asks for — *"en modo entity manden el `dataSource` completo junto
 * con el `visualizationConfig`; si no lo mandan, los bindings se guardan tal
 * cual y no se les completa `field`/`aggregate`"* — and changing it is no
 * longer a silent regeneration but a refusal: a saved widget keeps the
 * dataset it was created from, and the backend says so (see
 * `savedWidgetLock`). So the whole payload goes, and an edit the backend
 * will not take is reported to the author instead of being quietly dropped
 * here (CT-5641).
 *
 * @param {object} payload The full `buildWidgetPayload` result.
 */
export const toUpdatePayload = (payload) => payload;

export default toUpdatePayload;
